<template>
  <v-card
    class="elevation-0 mb-n1 px-2 py-3 transparent-border"
    color="alert shadow-alert"
    tile
  >
    <div class="event-alert d-flex flex-row px-4">
      <div>
        <v-icon color="red">$iconBell</v-icon>
      </div>
      <div v-html="text" />
    </div>
  </v-card>
</template>
<script>
export default {
  name: "EventCardAlert",
  props: {
    text: {
      type: String,
      default: ""
    }
  }
};
</script>
<style lang="scss">
.event-alert {
  min-height: 30px;
  max-height: 130px;

  font-size: 12px !important;
  align-items: center;
  i {
    font-size: 18px !important;
    margin-right: 14px;
  }
  p {
    margin-bottom: 0 !important;
  }
}
</style>
